// Label width measurement function
function measureLabelWidth(label) {
  const originalFontSize = label.style.fontSize;

  label.style.fontSize = "70%";
  label.style.visibility = "hidden";

  const width = label.getBoundingClientRect().width;
  const textLength = label.textContent.length;

  const finalWidth = width + textLength + 10;

  label.style.fontSize = originalFontSize;
  label.style.visibility = "visible";

  return finalWidth;
}

// Floating label animation
document.addEventListener("DOMContentLoaded", () => {
  const inputs = document.querySelectorAll(".my-input");
  const labels = document.querySelectorAll(".floating-label");

  inputs.forEach((input, index) => {
    const label = labels[index];
    let isFloated = false;

    function floatLabel() {
      if (!isFloated) {
        label.classList.add("floated");
        input.style.paddingTop = "20px";
        input.style.paddingBottom = "8px";
        isFloated = true;
      }
    }

    function unfloatLabel() {
      if (
        isFloated &&
        !input.value.trim() &&
        document.activeElement !== input
      ) {
        label.classList.remove("floated");
        input.style.paddingTop = "16px";
        input.style.paddingBottom = "16px";
        isFloated = false;
      }
    }

    input.addEventListener("focus", floatLabel);
    input.addEventListener("blur", unfloatLabel);
    input.addEventListener("input", () => {
      if (input.value.trim()) {
        floatLabel();
      }
      // Don't unfloat on input - only on blur
    });

    // Check if input has value on page load
    if (input.value.trim()) {
      floatLabel();
    }
  });
});

// Dynamic SVG creation and animation
document.addEventListener("DOMContentLoaded", function () {
  const inputContainers = document.querySelectorAll(".filed-input");

  inputContainers.forEach((inputContainer) => {
    const input = inputContainer.querySelector(".my-input");
    const label = inputContainer.querySelector(".floating-label");

    // Create SVG dynamically
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("class", "mySvg");
    svg.setAttribute("fill", "none");
    svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");

    const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path.setAttribute("class", "myPath");
    path.setAttribute("stroke", "#A07B35");
    path.setAttribute("stroke-width", "2");

    svg.appendChild(path);
    inputContainer.insertBefore(svg, input);

    // Set responsive SVG dimensions and paths
    svg.setAttribute("width", "300");
    svg.setAttribute("height", "53");
    svg.setAttribute("viewBox", "0 0 300 53");

    // Define SVG paths for different states
    const initialD = `M299 10V43C299 47.9706 294.971 52 290 52H10C5.02944 52 1 47.9706 1 43V10C1 5.02944 5.02944 1 10 1H80H290C294.971 1 299 5.02944 299 10Z`;
    const focusD = `M17 1H11C5.47715 1 1 5.47715 1 11V42C1 47.5228 5.47715 52 11 52H289C294.523 52 299 47.5228 299 42V11C299 5.47715 294.523 1 289 1H150`;

    function updateSVG() {
      const hasContent = input.value.trim() !== "";
      const isFocused = document.activeElement === input;
      const isLabelFloated = label && label.classList.contains("floated");

      if (hasContent || isFocused || isLabelFloated) {
        // Has content, focused, or label is floated: show border with gap
        path.setAttribute("d", focusD);
      } else {
        // Empty, unfocused, and label not floated: show full border
        path.setAttribute("d", initialD);
      }
    }

    input.addEventListener("focus", updateSVG);
    input.addEventListener("blur", updateSVG);
    input.addEventListener("input", updateSVG);

    // Initial state
    path.setAttribute("d", initialD);
    updateSVG();
  });
});
